import './qrCodeViewerComponent.scss'
import React, {useEffect, useState} from 'react';
import HeadingComponent from '../heading/headingComponent';
import ButtonComponent from "../core/button/ButtonComponent";
import DownloadIcon from '@mui/icons-material/Download';
import {CommonService} from "../../services";

export interface QrCodeFormComponentProps {
    attachment?: any;
    onClose?: any;
}


const QrCodeViewComponent = (props: QrCodeFormComponentProps) => {
    const {attachment, onClose} = props;

    const [attachmentPreview, setAttachmentPreview] = useState<any>();

    useEffect(() => {
        if (attachment) {
            setAttachmentPreview(attachment);
        }
    }, [attachment]);


    return (
        <div className="qrCode-view-screen screen t-form-screen">
            <div className={'t-form'}>
                <div className={'no-form'}>
                    <div className={'t-form-controls-wrapper'}>
                        <HeadingComponent title={'QR Code Details'}/>
                        <div className="qrCode-image-wrapper mrg-top-20">
                            <img height={205}
                                 width={205}
                                 className={'qrCode-image'}
                                 src={attachmentPreview?.url} alt={"Attachment"}/>
                        </div>
                        <div className={"download-qrcode-button"}>
                            <ButtonComponent
                                startIcon={<DownloadIcon/>}
                                variant={"outlined"}
                                size={"small"}
                                color={"secondary"}
                                fullWidth={false}
                                handleClick={() => {
                                    CommonService.downloadFile(attachmentPreview?.url, attachmentPreview?.title, attachmentPreview?.memeType)
                                }}
                            >
                                Download
                            </ButtonComponent>
                        </div>
                    </div>
                    <div className={"drawer-actions form-action-section"}>
                        <ButtonComponent
                            color={'primary'}
                            variant={"contained"}
                            fullWidth={true}
                            handleClick={() => {
                                onClose();
                            }}
                        >
                            Close
                        </ButtonComponent>
                    </div>
                </div>
            </div>

        </div>
    )
};

export default QrCodeViewComponent;